import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllGeofenceVehicleSummaryReport } from "../../../Apis/GeofenceReports/geofenceSummaryReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../../Common/ShimmerLoader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import isGHMC from "../../../Common/helper/helpar";
import Select from "react-select";
const GeofenceVehicleSummaryData = ({ t }) => {
  const headers = ["vehicleNumber", "fromLocation","toLocation", "inTime","outTime","duration"];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // New state for filtered data
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);



  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await AllGeofenceVehicleSummaryReport(startDate, endDate);
      const formattedData = response.data.map((item) => ({
        ...item,
        geofenceName: item.geoFenceName || "N/A",
      }));
      console.log(formattedData, "formattedData");
      
      setAllTripsTonnage(formattedData); // Set all data to the state
      setIsLoading(false);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        // Handle network errors or other unexpected errors
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }
    }
    setIsLoading(false);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    fetchTripsTonnageData(startDate, endDate);
    if (selectedVehicle) {
      // Filter data based on selected vehicle
      const filteredData = getAllTripsTonnage.filter(
        (item) => item.vehicleNumber === selectedVehicle.value
      );
      setFilteredData(filteredData); // Set filtered data to the state
    } else {
      setFilteredData([]); // If no vehicle is selected, set filtered data to empty array
    }
  };
  
  const handleClear = async () => {
    // Reset selected vehicle and filtered data
    setSelectedVehicle(null);
    setFilteredData([]);
    // Fetch data again with the previous start and end dates
    await fetchTripsTonnageData(getStartOfCurrentDate(), getCurrentDateTime());
  };
  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;  
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${
        currentDate.getMonth() + 1
    }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Geofence Summary Transaction Reports`;
    const downloadDateTime = `Report on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    // Define styles
 const boldFont = { bold: true };

 // Add the downloadDateTime to the correct row and columns, and ensure formatting
 worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
 worksheet.mergeCells(1, 2, 1, 8); // Merge cells for downloadDateTime from column 2 to 4
 worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
 worksheet.getCell(1, 2).font = boldFont; // Set font style
 worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content
 
 // Apply styles to the merged cells (B1, C1, D1)
 for (let col = 2; col <= 8; col++) {
   worksheet.getCell(1, col).font = boldFont; // Set styles individually
   worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
 }
 
 // Add "Zone Details" to the correct row and columns, and ensure formatting
 worksheet.addRow(["", "", "Geofence Summary Transaction Reports", ""]); // Update array length to match new cell range
 worksheet.mergeCells(2, 2, 2, 8); // Merge cells for Zone Details from column 2 to 4
 worksheet.getCell(2, 2).value = "Geofence Summary Transaction Reports"; // Ensure the value is set after merging
 worksheet.getCell(2, 2).font = boldFont; // Set font style
 worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content
 
 // Apply styles to the merged cells (B2, C2, D2)
 for (let col = 2; col <= 8; col++) {
   worksheet.getCell(2, col).font = boldFont; // Set styles individually
   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
 }
 
    

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Vehicle Number",
        // "Geofence Name",
        "From Location",
        "To Location",
        "In Time",
        "Out Time",
        "Duration",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" }; // Left align the cell content
        if (colNumber >= 1 && colNumber <=13) {
            // Apply background color only to specific cells
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" } // Red background color
            };
        }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
        worksheet.addRow([
            index + 1,
            item.vehicleNumber?? "N/A",
            // item.geoFenceName ?? "N/A",
            item.fromLocation?? "N/A",     
            item.toLocation?? "N/A",
            item.inTime?? "N/A",
            item.outTime?? "N/A",
            item.duration?? "N/A",
        ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber >= 1 && colNumber <= 13) {
                // Align the columns from 1 to 4 to the left
                cell.alignment = { horizontal: "left" };
            } else {
                // Align the rest of the columns to the center
                cell.alignment = { horizontal: "center" };
            }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
        { width: 5 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "GeofenceSummaryTransactionReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
};

  return (
    <>
      {isLoading ? (
        <TableLoader height={500} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
            <h4 class="text-start mb-3">{t("Geofence Vehicle Summary Report")} </h4>
              <div className="card">
                <div className="card-body p-3">
                <div className="row align-items-end">
                  <div className="col-md-10">
                  <form onSubmit={handleFormSubmit}>
                    <div className="row align-items-end" style={{ textAlign: "left"}}
                    >
                      <div className="col-md-3">
                        <label>From Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="FromDate"
                          style={inputStyle}
                          value={startDate}
                          className="form-control"
                          max={endDate ? endDate : getCurrentDateTime()}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>To Date & Time:</label>
                        <input
                          type="datetime-local"
                          name="ToDate"
                          style={inputStyle}
                          value={endDate}
                          className="form-control"
                          min={startDate}
                          max={getCurrentDateTime()}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label>Select Vehicle</label>
                        <Select
                          classNamePrefix="CreatableSelect"
                          value={selectedVehicle}
                          onChange={(selectedOption) =>
                            setSelectedVehicle(selectedOption)
                          }
                          options={Array.from(
                            new Set(
                              getAllTripsTonnage.map(
                                (vehicle) => vehicle.vehicleNumber
                              )
                            )
                          ).map((vehicleNumber) => ({
                            value: vehicleNumber,
                            label: vehicleNumber,
                          }))}
                          placeholder="Select Vehicle"
                          backspaceRemovesValue
                          isSearchable
                          isClearable
                        />
                      </div>
                      <div className="col-md-3">
                        <button
                         type="submit"
                         className={`btn ${isProd ? "search-ghmc" : "search-swm"}`}>
                          Search
                        </button>
                        <button
                          type="button"
                          onClick={handleClear}
                          className={`btn ms-3 ${isProd ? "search-ghmc" : "search-swm"}`}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </form>
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-excel ms-auto"
                      onClick={downloadAsExcel}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
                 
             
               
                  <div className="mt-3">
                    <TableComponent isLoading={isLoading}
                      DataFetchURL={
                        filteredData.length > 0
                          ? filteredData
                          : getAllTripsTonnage
                      }
                      headers={headers}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
// Rest of the component remains the same

export default withTranslation()(GeofenceVehicleSummaryData);

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  // padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  // borderRadius: "5px",
  // color: "#fff",
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
